import { collection, doc, setDoc } from 'firebase/firestore';
import { db } from '../firebase/config';
import { subnetNames } from '../utils/subnetNames';
import { subnetDescriptions } from '../utils/subnetDescriptions';

/**
 * Creates or updates the subnet_list collection in Firestore
 * with all subnet information including descriptions, GitHub links, and X links
 */
export async function createSubnetListCollection(): Promise<void> {
  try {
    console.log('Starting to create subnet_list collection...');
    
    // Get all subnets from the subnetNames object
    const subnets = Object.entries(subnetNames);
    
    for (const [netuidStr, name] of subnets) {
      const netuid = parseInt(netuidStr);
      
      // Create the main subnet document
      const subnetRef = doc(db, 'subnet_list', netuidStr);
      
      // Basic subnet info
      await setDoc(subnetRef, {
        netuid,
        name,
        lastUpdated: new Date().toISOString()
      });
      
      console.log(`Created main document for subnet ${netuid}: ${name}`);
      
      // Get additional info from subnetDescriptions
      const subnetInfo = subnetDescriptions[netuid];
      
      if (subnetInfo) {
        // Create the info subcollection document
        const infoRef = doc(db, 'subnet_list', netuidStr, 'info', 'details');
        
        await setDoc(infoRef, {
          description: subnetInfo.description || '',
          github: subnetInfo.github || '',
          x: subnetInfo.x || '',
          website: subnetInfo.website || '',
          lastUpdated: new Date().toISOString()
        });
        
        console.log(`Created info subcollection for subnet ${netuid}`);
      }
    }
    
    console.log('Subnet list collection creation completed successfully');
  } catch (error) {
    console.error('Error creating subnet list collection:', error);
    throw error;
  }
}

/**
 * Updates a specific subnet's information
 */
export async function updateSubnetInfo(
  netuid: number,
  info: {
    description?: string;
    github?: string;
    x?: string;
    website?: string;
  }
): Promise<void> {
  try {
    const netuidStr = netuid.toString();
    
    // Update the info subcollection document
    const infoRef = doc(db, 'subnet_list', netuidStr, 'info', 'details');
    
    await setDoc(infoRef, {
      ...info,
      lastUpdated: new Date().toISOString()
    }, { merge: true });
    
    console.log(`Updated info for subnet ${netuid}`);
  } catch (error) {
    console.error(`Error updating subnet ${netuid} info:`, error);
    throw error;
  }
}